import { useQuery } from "react-query";

import { getRelease } from "api/dashboardBackend";
import useErrorScreen from "components/useErrorScreen";
import { isPlatformId } from "util/platform";

const useReleaseSpecificScreen = (
  platform: string | undefined,
  version: string | undefined,
) => {
  const fetchRelease = () => {
    if (!version) {
      return Promise.reject(new Error("Version is undefined"));
    }

    if (!platform) {
      return Promise.reject(new Error("Platform is undefined"));
    }

    if (!isPlatformId(platform)) {
      return Promise.reject(new Error(`Invalid platform: ${platform}`));
    }

    return getRelease(platform, version);
  };

  const { data, error, isError, isLoading } = useQuery(
    ["releases", platform, version],
    fetchRelease,
  );

  const errorComponent = useErrorScreen(isError, error);

  return {
    errorComponent,
    isLoading,
    platformId: platform && isPlatformId(platform) ? platform : null,
    release: data,
  };
};

export default useReleaseSpecificScreen;
